import { supabase } from '@/shared/lib/supabase';
import type { EleicaoSnapshot } from '@/shared/types';
import type { IEleicaoRepository } from '../domain/ports/IEleicaoRepository';

export const eleicaoRepository: IEleicaoRepository = {
  async snapshots() {
    const { data, error } = await supabase.rpc('eleicao_snapshots' as never);
    if (error) throw error;
    if (!Array.isArray(data)) return [];
    // Só Presidente no ar: Governador e Senador de GO foram decididos no 1º turno (pedido do
    // tenant, 2026-10-21). Remover este filtro devolve o carrossel completo.
    return (data as EleicaoSnapshot[]).filter(s => (s.cargo ?? 'presidente') === 'presidente');
  },
};
